import { Form, Modal } from 'react-bootstrap';
import React, { ReactNode, useState } from 'react';

export type StorePickItem = {
  storeId: number;
  storeName: string;
};

type StorePickButtonProps = {
  label: string;
  stores: StorePickItem[];
  selectedId?: number;
  onSelect: (storeId: number) => void;
  onQueryChange?: (query: string) => void;
  extra?: ReactNode;
};

const StorePickButton = ({
  label,
  stores,
  selectedId,
  onSelect,
  onQueryChange,
  extra,
}: StorePickButtonProps) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const shown = (stores || []).filter((store) => {
    if (onQueryChange || !query.trim()) return true;
    const word = query.trim();
    return String(store.storeId).includes(word) || String(store.storeName || '').includes(word);
  });

  return (
    <>
      <button type="button" className="reload_wrapper store_pick_btn" onClick={() => setOpen(true)}>
        <span>{label}</span>
        {extra}
      </button>
      <Modal show={open} onHide={() => setOpen(false)} fullscreen className="store_pick_modal">
        <Modal.Header closeButton>
          <Modal.Title>지점 선택</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            lang="ko"
            inputMode="text"
            enterKeyHint="done"
            autoCapitalize="off"
            autoComplete="off"
            placeholder="지점 번호 또는 지점명 검색"
            className="store_search_input"
            value={query}
            onPointerDown={(event) => {
              event.currentTarget.focus();
            }}
            onChange={(event) => {
              setQuery(event.target.value);
              onQueryChange?.(event.target.value);
            }}
          />
          <ul className="store_pick_list">
            {shown.map((store) => (
              <li key={store.storeId}>
                <button
                  type="button"
                  className={store.storeId === selectedId ? 'selected' : ''}
                  onClick={() => {
                    setOpen(false);
                    setQuery('');
                    onSelect(store.storeId);
                  }}
                >
                  {store.storeName}
                </button>
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StorePickButton;
